import { render, staticRenderFns } from "./LSelect2.vue?vue&type=template&id=83792a18"
import script from "./LSelect2.vue?vue&type=script&lang=js"
export * from "./LSelect2.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./LSelect2.vue?vue&type=style&index=1&id=83792a18&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports